import React, { useState } from 'react';
import api from '../config/api';

const PagamentoCartao = ({ showAlert, setLoading }) => {
    const [tipoPlano, setTipoPlano] = useState('MENSAL');
    const [formData, setFormData] = useState({
        numeroCartao: '',
        nomeCartao: '',
        mesValidade: '',
        anoValidade: '',
        cvv: '',
        cobrancaAutomatica: true
    });

    const DADOS_TESTE = {
        usuarioId: localStorage.getItem('usuarioId') || 1,
        valor: tipoPlano === 'MENSAL' ? 99.90 : 999.90
    };

    const formatCardNumber = (value) => {
        const cleaned = value.replace(/\D/g, '');
        let formatted = '';
        for (let i = 0; i < cleaned.length && i < 16; i++) {
            if (i > 0 && i % 4 === 0) {
                formatted += ' ';
            }
            formatted += cleaned[i];
        }
        return formatted;
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        
        let newValue = value;
        
        if (name === 'numeroCartao') {
            newValue = formatCardNumber(value);
        } else if (name === 'mesValidade') {
            newValue = value.replace(/\D/g, '').substring(0, 2);
        } else if (name === 'anoValidade') {
            newValue = value.replace(/\D/g, '').substring(0, 4);
        } else if (name === 'cvv') {
            newValue = value.replace(/\D/g, '').substring(0, 4);
        }

        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : newValue
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const numeroLimpo = formData.numeroCartao.replace(/\s/g, '');
        
        if (numeroLimpo.length < 13) {
            showAlert('Número do cartão inválido', 'error');
            return;
        }

        if (!formData.nomeCartao || !formData.mesValidade || !formData.anoValidade || !formData.cvv) {
            showAlert('Por favor, preencha todos os campos', 'error');
            return;
        }

        setLoading(true);

        try {
            const payload = {
                usuarioId: DADOS_TESTE.usuarioId,
                valor: DADOS_TESTE.valor,
                tipoPagamento: 'CARTAO_CREDITO',
                tipoPlano: tipoPlano,
                numeroCartao: numeroLimpo,
                nomeCartao: formData.nomeCartao,
                mesValidade: formData.mesValidade,
                anoValidade: formData.anoValidade,
                cvv: formData.cvv,
                descricaoAutomatica: formData.cobrancaAutomatica,
                descricao: `Assinatura ${tipoPlano === 'MENSAL' ? 'Mensal' : 'Anual'} - ${new Date().toLocaleDateString('pt-BR')}`
            };

            console.log('Enviando para backend:', payload);

            const response = await api.post('/pagamento', payload);

            if (response.data) {
                const message = formData.cobrancaAutomatica 
                    ? '✅ Pagamento processado! Seu cartão será cobrado automaticamente.'
                    : '✅ Pagamento processado com sucesso!';
                
                showAlert(message, 'success');
                
                // Limpar formulário
                setFormData({
                    numeroCartao: '',
                    nomeCartao: '',
                    mesValidade: '',
                    anoValidade: '',
                    cvv: '',
                    cobrancaAutomatica: true
                });
            }
        } catch (error) {
            console.error('Erro na requisição:', error.response?.data || error.message);
            const errorMessage = error.response?.data?.mensagem || 'Erro ao processar pagamento';
            showAlert(errorMessage, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="tab-content active">
            <div className="info-box">
                ℹ️ Seus dados de cartão são processados com segurança pelo Mercado Pago
            </div>

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="tipoPlano">Tipo de Plano</label>
                    <select 
                        id="tipoPlano"
                        value={tipoPlano}
                        onChange={(e) => setTipoPlano(e.target.value)}
                        required
                    >
                        <option value="MENSAL">Mensal - R$ 350</option>
                        <option value="ANUAL">Anual - R$ 3.850,00</option>
                    </select>
                </div>

                <div className="form-group">
                    <label htmlFor="numeroCartao">Número do Cartão</label>
                    <input 
                        type="text" 
                        id="numeroCartao"
                        name="numeroCartao"
                        value={formData.numeroCartao}
                        onChange={handleInputChange}
                        placeholder="0000 0000 0000 0000"
                        maxLength="19"
                        required
                    />
                </div>

                <div className="form-group">
                    <label htmlFor="nomeCartao">Nome do Titular</label>
                    <input 
                        type="text" 
                        id="nomeCartao"
                        name="nomeCartao"
                        value={formData.nomeCartao}
                        onChange={handleInputChange}
                        placeholder="Como está no cartão"
                        required
                    />
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="mesValidade">Mês Validade</label>
                        <input 
                            type="text" 
                            id="mesValidade"
                            name="mesValidade"
                            value={formData.mesValidade}
                            onChange={handleInputChange}
                            placeholder="MM"
                            maxLength="2"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="anoValidade">Ano Validade</label>
                        <input 
                            type="text" 
                            id="anoValidade"
                            name="anoValidade"
                            value={formData.anoValidade}
                            onChange={handleInputChange}
                            placeholder="YYYY"
                            maxLength="4"
                            required
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="cvv">CVV</label>
                    <input 
                        type="text" 
                        id="cvv"
                        name="cvv"
                        value={formData.cvv}
                        onChange={handleInputChange}
                        placeholder="123"
                        maxLength="4"
                        required
                    />
                </div>

                <div className="checkbox-group">
                    <input 
                        type="checkbox" 
                        id="cobrancaAutomatica"
                        name="cobrancaAutomatica"
                        checked={formData.cobrancaAutomatica}
                        onChange={handleInputChange}
                    />
                    <label htmlFor="cobrancaAutomatica">
                        Cobrar automaticamente a cada mês (Recomendado)
                    </label>
                </div>

                <div className="warning-box">
                    <strong>⚠️ Importante:</strong> Se marcar "Cobrar automaticamente", seu cartão será 
                    cobrado automaticamente a cada 31 dias. Você poderá cancelar a qualquer momento.
                </div>

                <button type="submit" className="btn-submit">
                    Processar Pagamento
                </button>
            </form>
        </div>
    );
};

export default PagamentoCartao;
